import { Outlet, Navigate } from "react-router-dom";

const SemiAdmin = (props) => {
   return props.semiAdmin || props.admin ? <Outlet /> : <Navigate to="/login" />;
};

export default SemiAdmin;
